<switch-overlay
  [tabs]="tabs"
  [activeTab]="activeAccountType"
  (confirm)="onConfirm($event)"
  title="Please select your account"
  buttonText="Switch account"
></switch-overlay>
